var _rect, _path, _path2, _circle, _line, _line2, _line3, _line4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpaceProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.4,
    height: 70.4,
    rx: 12,
    fill: "url(#paint0_linear_28_292)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8 47.9489C42.0437 47.9489 47.9158 43.3509 47.9158 37.6791C47.9158 37.4509 47.9063 37.2245 47.8876 37C50.813 38.8268 52.6 41.2674 52.6 43.9485C52.6 49.6102 44.6307 54.2 34.8 54.2C24.9693 54.2 17 49.6102 17 43.9485C17 41.2674 18.787 38.8268 21.7124 37C21.6937 37.2245 21.6842 37.4509 21.6842 37.6791C21.6842 43.3509 27.5564 47.9489 34.8 47.9489Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.033 35.0231C44.7098 33.1113 45.7263 30.606 45.7263 27.8632C45.7263 21.8636 40.8627 17 34.8632 17C28.8636 17 24 21.8636 24 27.8632C24 30.6059 25.0164 33.1112 26.6931 35.0229L33.3653 44.8503C34.0836 45.9084 35.6428 45.9084 36.3611 44.8503L43.033 35.0231Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 28,
    r: 7,
    fill: "url(#paint1_linear_28_292)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.0737,
    y1: 25.6,
    x2: 41.6526,
    y2: 25.6,
    stroke: "white",
    strokeWidth: 0.905263,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.0737,
    y1: 31.0316,
    x2: 41.6526,
    y2: 31.0316,
    stroke: "white",
    strokeWidth: 0.905263,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 32.6,
    y1: 34.6526,
    x2: 32.6,
    y2: 21.0737,
    stroke: "white",
    strokeWidth: 0.905263,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 37.1263,
    y1: 34.6526,
    x2: 37.1263,
    y2: 21.0737,
    stroke: "white",
    strokeWidth: 0.905263,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_292",
    x1: 16,
    y1: -6.24223e-7,
    x2: 64.8,
    y2: 70.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9C64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FD7D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD573C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_292",
    x1: 35,
    y1: 21,
    x2: 35,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD764E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceProduct);
export default __webpack_public_path__ + "static/media/space-product.b7eba1694dbba1d54f3c6ceab3996476.svg";
export { ForwardRef as ReactComponent };